import React, { ReactNode } from 'react';

import { Badge, Box, Center } from '@chakra-ui/react';

import { CloseIcon } from 'components/Icons';

interface Props {
  onRemove(): void;
  children: ReactNode;
}

export const GraphFilterBox = (props: Props) => {
  const { children, onRemove } = props;

  return (
    <Box
      border={'1px solid'}
      borderColor={'gray.100'}
      borderRadius={4}
      p={2}
      pos={'relative'}
    >
      <Badge
        borderRadius="full"
        bg="red"
        color="white"
        w={4}
        h={4}
        p={0.5}
        pos={'absolute'}
        right={-2}
        top={-2}
        cursor={'pointer'}
        onClick={() => onRemove()}
      >
        <Center w="full" h="full">
          <CloseIcon />
        </Center>
      </Badge>
      {children}
    </Box>
  );
};
